export default __webpack_public_path__ + "static/media/showcase-payroll.20f3d559.jpg";